import React from "react";

export type TTabSearchIconProps = React.SVGAttributes<SVGElement>;

export function TabSearchIcon({ ...rest }: TTabSearchIconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <mask
        id="tabSearchMask"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#tabSearchMask)">
        <path
          d="M4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V10H13V6H4V18H10V20H4ZM4 18V9V10V6V18ZM21.6 22L18.9 19.3C18.5333 19.5167 18.15 19.6875 17.75 19.8125C17.35 19.9375 16.9333 20 16.5 20C15.25 20 14.1875 19.5625 13.3125 18.6875C12.4375 17.8125 12 16.75 12 15.5C12 14.25 12.4375 13.1875 13.3125 12.3125C14.1875 11.4375 15.25 11 16.5 11C17.75 11 18.8125 11.4375 19.6875 12.3125C20.5625 13.1875 21 14.25 21 15.5C21 15.9333 20.9375 16.35 20.8125 16.75C20.6875 17.15 20.5167 17.5333 20.3 17.9L23 20.6L21.6 22ZM16.5 18C17.2 18 17.7917 17.7583 18.275 17.275C18.7583 16.7917 19 16.2 19 15.5C19 14.8 18.7583 14.2083 18.275 13.725C17.7917 13.2417 17.2 13 16.5 13C15.8 13 15.2083 13.2417 14.725 13.725C14.2417 14.2083 14 14.8 14 15.5C14 16.2 14.2417 16.7917 14.725 17.275C15.2083 17.7583 15.8 18 16.5 18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
